import React from "react";
import Hero from "../components/Hero";
import Partners from "../components/Partners";
import Services from "../components/Services";
import Products from "../components/Products";
import Insights from "../components/Insights";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";
import Blogs from "../components/BlogSection";

const HomeGhana = () => {
  return (
    <>
      <Hero />
      <Partners />
      <Services />
      <Products />
      <Blogs />
      <Clients />
      <Testimonials />
      {/* <AboutUs /> */}
      {/* <ContactUs /> */}
    </>
  );
};

export default HomeGhana;
